import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@deal/components'
import Check from './check.svg'
import { CategoryType } from '#src/generated/graphql'
import styles from './styles.css'

interface Props {
  type?: CategoryType | null
  onSubmit: () => void
  conversationId: string
  expertFirstName?: string | null
  isPlaceholderExpert: boolean | null
}

interface CurationCopyProps {
  type?: CategoryType | null
  isPlaceholderExpert: boolean | null
  expertFirstName?: string | null
}

const CurationTitle: React.SFC<CurationCopyProps> = ({
  type,
  isPlaceholderExpert,
  expertFirstName
}) => {
  if (isPlaceholderExpert) {
    return <>We're finding your expert</>
  } else {
    if (type && type === CategoryType.SERVICE) {
      return expertFirstName ? (
        <>{expertFirstName} is working on your request!</>
      ) : (
        <>We're working on your request!</>
      )
    } else {
      return expertFirstName ? (
        <>{expertFirstName} is working on your recommendations!</>
      ) : (
        <>We're working on your recommendations!</>
      )
    }
  }
}

const CurationBody: React.SFC<CurationCopyProps> = ({
  isPlaceholderExpert,
  type,
  expertFirstName
}) => {
  if (isPlaceholderExpert) {
    return (
      <>
        We’re searching for the right expert to match you with, so you can get hand-picked
        recommendations and notes. Once they’re ready, we’ll send you a message. In the meantime,
        feel free to ask us any questions!
      </>
    )
  } else {
    if (type && type === CategoryType.SERVICE) {
      return (
        <>
          You'll receive a personalized recommendation shortly. Feel free to ask{' '}
          {expertFirstName ? expertFirstName : ''} questions in the meantime and we’ll send you a
          message as soon as it’s ready!
        </>
      )
    } else {
      return (
        <>
          You'll receive a hand-picked set of recommendations with personalized notes. Feel free to
          ask {expertFirstName ? expertFirstName : ''} questions in the meantime and we’ll send you
          a message as soon as it’s ready!
        </>
      )
    }
  }
}

const EmptyCurations: React.SFC<Props> = ({
  expertFirstName,
  type,
  onSubmit,
  conversationId,
  isPlaceholderExpert
}) => (
  <>
    <div className={styles.flex}>
      <div className={styles.bullets}>
        <span className={styles.bulletActive}>
          <Check className={styles.check} width={10} />
        </span>
        <span className={styles.separator} />
        <span className={styles.bulletCurrent} />
        <span className={styles.separator} />
        <span className={styles.bulletInactive} />
      </div>
      <div className={styles.smallTitle}>
        {isPlaceholderExpert ? 'Match with an expert' : 'Receive recommendations'}
      </div>
    </div>
    <div className={styles.title}>
      <CurationTitle
        type={type}
        isPlaceholderExpert={isPlaceholderExpert}
        expertFirstName={expertFirstName}
      />
    </div>
    <div className={styles.subTitle}>
      <CurationBody
        type={type}
        isPlaceholderExpert={isPlaceholderExpert}
        expertFirstName={expertFirstName}
      />
    </div>
    <div className={styles.buttonContainer}>
      <Link to={`/inbox/${conversationId}`}>
        <Button className={styles.button} onClick={onSubmit}>
          {isPlaceholderExpert ? `Chat with us` : `Chat with ${expertFirstName || 'your expert'}`}
        </Button>
      </Link>
    </div>
  </>
)

export default EmptyCurations
